import { createFileRoute } from "@tanstack/react-router";

import { CreateOrderPage } from "@/components/Pages/Orders/CreateOrder.page";

export const Route = createFileRoute("/_guard/orders/create")({
  component: CreateOrderPage,
});
